import { GetAllBlogsResponse } from "lib/worker/api/get_all_blogs";
import { GetServerSideProps } from "next";
import { CheckWithPrefix } from "lib/infomation_vender/document";
import SectionBlog from "./section_blog";

interface Props {
  blogs: GetAllBlogsResponse[];
}

function ViewAllBlog(props: Props) {
  const { blogs } = props;

  return (
    <div className="container">
      <div>
        {blogs.length == 0 ? (
          <>
            <div
              className="card color-font-card"
              style={{ paddingTop: 15, paddingBottom: 0, marginTop: 20 }}
            >
              <p className="text-center">
                ยังไม่มี <span>บทความ</span> ในตอนนี้
              </p>
            </div>
          </>
        ) : (
          <>
            <div className="row wrapper">
              {blogs.map((el, i) => {
                return (
                  <SectionBlog
                    Title={el.Title}
                    Key={i}
                    Ref={el.Ref}
                    Image={el.Image}
                    DisplayCreatedAt={el.DisplayCreatedAt}
                    Desc={el.Desc}
                  ></SectionBlog>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      infomation: infomation,
    },
  };
};

export default ViewAllBlog;
